<ng-container *ngIf="!isLoading && minAgeForm; else loading">
  <div class="responsive-card">
    <div class="d-flex flex-column gap-4">
      <div class="responsive-card-title" i18n>Age for Minimum Calculation</div>

      <ng-container [formGroup]="minAgeForm">
        <app-system-banner
          *ngIf="!!(displayableBanner$ | async)"
          [banner]="displayableBanner$ | async"
          (textButtonClicked)="cancelScheduledChangesClicked.emit()" />

        <div *ngIf="!(spouse$ | async)" class="responsive-card-description">
          {{ noSpouseDescription }}
        </div>

        <ng-container *ngIf="hasScheduledChanges$ | async; else editableMode">
          <div class="d-flex flex-column">
            <div class="option-label" i18n>Current</div>
            <app-vb-minimum-age-person-card
              *ngIf="currentMinimumDetails$ | async as current"
              [name]="current.minimumAgeName"
              [dateOfBirth]="current.minimumAgeDateOfBirth"
              [label]="currentMinimumLabel$ | async"
              [showRadioButton]="false" />

            <div class="mt-3">
              <div *ngIf="newSectionLabel$ | async as newLabel" class="option-label">{{ newLabel }}</div>
              <app-vb-minimum-age-person-card
                *ngIf="scheduledMinimumAgeChanges$ | async as scheduled"
                [name]="scheduled.minimumAgeName"
                [dateOfBirth]="scheduled.minimumAgeDateOfBirth"
                [label]="scheduledMinimumLabel$ | async"
                [showRadioButton]="false" />
            </div>
          </div>
        </ng-container>

        <ng-template #editableMode>
          <div class="d-flex flex-column">
            <app-vb-minimum-age-person-card
              [name]="memberName"
              [dateOfBirth]="memberDateOfBirth"
              [label]="memberAgeLabel"
              [showRadioButton]="true"
              [radioControlId]="'member-age'"
              [radioName]="'minimumAgeDateOfBirth'"
              [radioValue]="memberDateOfBirth"
              [radioFormControl]="minAgeForm.controls.minimumAgeDateOfBirth"
              (selected)="onMemberSelected()" />

            <div class="mt-3" *ngIf="spouse$ | async as spouse">
              <app-vb-minimum-age-person-card
                [name]="spouse.firstName + ' ' + spouse.lastName"
                [dateOfBirth]="spouse.birthDate"
                [label]="spouseAgeLabel"
                [showRadioButton]="true"
                [radioControlId]="'spouse-age'"
                [radioName]="'minimumAgeDateOfBirth'"
                [radioValue]="spouse.birthDate"
                [radioFormControl]="minAgeForm.controls.minimumAgeDateOfBirth"
                (selected)="onSpouseSelected()" />
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="responsive-card">
    <lib-loading-shimmer [height]="'29.25rem'" [width]="'100%'" />
  </div>
</ng-template>
